import { render, staticRenderFns } from "./FurnitureSimulator.vue?vue&type=template&id=6a69809c&scoped=true&"
import script from "./FurnitureSimulator.vue?vue&type=script&lang=js&"
export * from "./FurnitureSimulator.vue?vue&type=script&lang=js&"
import style0 from "./FurnitureSimulator.vue?vue&type=style&index=0&id=6a69809c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69809c",
  null
  
)

export default component.exports